import styled from 'styled-components'
import { Card as BootstrapCard } from 'react-bootstrap'

export const BaseCard = styled(BootstrapCard)`
  background: ${({ theme }) => theme.colors.background.card};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  transition: ${({ theme }) => theme.transitions.default};
  overflow: hidden;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-2px);
  }

  .card-header {
    background: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: ${({ theme }) => theme.spacing.md};
  }

  .card-body {
    padding: ${({ theme }) => theme.spacing.md};
  }

  .card-footer {
    background: transparent;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: ${({ theme }) => theme.spacing.md};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    .card-header,
    .card-body,
    .card-footer {
      padding: ${({ theme }) => theme.spacing.sm};
    }
  }
`

export interface CardProps {
  $variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'info'
  $gradient?: boolean
}

export const StyledCard = styled(BaseCard)<CardProps>`
  ${({ $variant, $gradient, theme }) => {
    if ($gradient && $variant) {
      return `
        background: ${theme.colors.gradients[$variant]};
      `
    }
    return ''
  }}
`
